export const PermissionVariables = {
    pages: "Pages",
    dashboard: "Pages.Dashboard",
    getTemplates:"Pages.GetTemplates",
    getCurrencies:"Pages.GetCurrencies",
    getIndustries:"Pages.GetIndustries",
    client: "Pages.Client",
    addClient: "Pages.Client.AddClient",
    editClient: "Pages.Client.EditClient",
    deleteClient:"Pages.Client.DeleteClient",
    invoices:"Pages.Invoices",
    createInvoice:"Pages.Invoices.CreateInvoice",
    editInvoice:"Pages.Invoices.EditInvoice",
    deleteInvoice:"Pages.Invoices.DeleteInvoice",
    currency:"Pages.Invoices.Currency",
    createCurrency:"Pages.Invoices.Currency.CreateCurrency",
    updateCurrency:"Pages.Invoices.Currency.EditCurrency",
    deleteCurrency:"Pages.Invoices.Currency.DeleteCurrency",
    industry:"Pages.Invoices.Industry",
    createIndustry:"Pages.Invoices.Industry.CreateIndustry",
    editIndustry:"Pages.Invoices.Industry.EditIndustry",
    deleteIndustry:"Pages.Invoices.Industry.DeleteIndustry",
    invoicePayment:"Pages.Invoices.Industry.InvoicePayment",
    items: "Pages.Items",
    addItem: "Pages.Items.AddItem",
    editItem:"Pages.Items.EditItem",
    deleteItem:"Pages.Items.DeleteItem",
    paymentSchedule: "Pages.PaymentSchedule",
    reports: "Pages.Reports",
    notifications:"Pages.Notifications",
    createNotification:"Pages.Notifications.createNotification",
    updateNotification:"Pages.Notifications.updateNotification",
    deleteNotification:"Pages.Notifications.deleteNotification",
    administration: "Pages.Administration",
    user: "Pages.Administration.User",
    createUser: "Pages.Administration.User.CreateUser",
    editUser: "Pages.Administration.User.EditUser",
    deleteUser: "Pages.Administration.User.DeleteUser",
    templates: "Pages.Administration.Templates",
    createTemplate: "Pages.Administration.Templates.CreateTemplate",
    editTemplate:"Pages.Administration.Templates.EditTemplate",
    settings: "Pages.Administration.Settings",
    invoiceNumberSequence: "Pages.Administration.Settings.InvoiceNumberSequence",
    tenantPaymentSettings:"Pages.Administration.TenantPaymentSettings",
    createPaymentSettings:"Pages.Administration.TenantPaymentSettings.CreatePaymentSettings",
    tenant: "Pages.Administration.Tenant",
    createTenant: "Pages.Administration.Tenant.CreateTenant",
    editTenant: "Pages.Administration.Tenant.EditTenant",
    deleteTenant:"Pages.Administration.Tenant.DeleteTenant",
    role: "Pages.Administration.Role",
    createRole: "Pages.Administration.Role.CreateRole",
    editRole: "Pages.Administration.Role.EditRole",
    deleteRole: "Pages.Administration.Role.DeleteRole",
    edition: "Pages.Administration.Edition",
    createEdition: "Pages.Administration.Edition.CreateEdition",
    editEdition: "Pages.Administration.Edition.EditEdition",
    deleteEdition: "Pages.Administration.Edition.DeleteEdition",
    subscriptionPayment:"Pages.Administration.SubscriptionPayment",
    permission:"Pages.Administration.Permission",
    mailSettings:"Pages.Administration.MailSettings",
    mailTemplate:"Pages.Administration.MailTemplate"
   
}
